import { Col, Row } from 'react-bootstrap';
import styles from './simpleresponsivecell.module.scss';

interface SimpleResponsiveCellProps {
  label: string;
  value: string;
}

export default function SimpleResponsiveCell({
  label,
  value,
}: SimpleResponsiveCellProps) {
  return (
    <Row sm={2} md={1} className="g-md-0 g-sm-2 readonly-form">
      <Col className={styles.labelContainer}>
        <span className="label">{label}</span>
      </Col>
      <Col>
        <span className="value">{value}</span>
      </Col>
    </Row>
  );
}
